var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.48,
    height: 14.48,
    viewBox: "134.519 321.999 14.48 14.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.563 7.563c0-3.867 3.133-7 7-7 3.866 0 7 3.133 7 7 0 3.866-3.134 7-7 7-3.867 0-7-3.134-7-7Zm8.241 3.274V7.563h2.002a.339.339 0 0 0 .24-.58L7.802 3.759a.336.336 0 0 0-.477 0L4.08 6.984a.339.339 0 0 0 .24.579h2.002v3.274a.34.34 0 0 0 .338.338h1.807a.34.34 0 0 0 .338-.338Z",
    fillRule: "evenodd",
    fill: "url(\"#a\")",
    transform: "rotate(-2 9289.085 -3675.668)",
    "data-name": "Icon awesome-arrow-alt-circle-up"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f04e23",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f68b1f",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.ea9952692fa2b6f28cb06c3f19571005.svg";
export { ForwardRef as ReactComponent };